import { useToastStore } from '@/store/toast'

const TONE: Record<string, string> = {
  success: 'border-green-300 bg-green-50 text-green-900',
  info: 'border-blue-300 bg-blue-50 text-blue-900',
  warn: 'border-amber-300 bg-amber-50 text-amber-900',
  error: 'border-red-300 bg-red-50 text-red-900',
}

const ICON: Record<string, string> = {
  success: 'pi-check-circle',
  info: 'pi-info-circle',
  warn: 'pi-exclamation-triangle',
  error: 'pi-times-circle',
}

/**
 * Renders the toast store (2026-10-07). The store has existed since the console's scaffold and 483
 * `toast.show` calls in 69 files push to it, but nothing rendered it: every success and error message of
 * the admin console was invisible (found when a refused order move showed nothing). Errors are announced
 * as alerts and stay longer (store/toast.ts).
 */
export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  if (!toasts.length) return null

  return (
    <div className="fixed bottom-4 right-4 z-[1000] flex flex-col gap-2 w-96 max-w-[calc(100vw-2rem)]" data-testid="toast-host">
      {toasts.map((t) => (
        <div
          key={t.id}
          role={t.severity === 'error' ? 'alert' : 'status'}
          className={`border rounded-lg shadow-lg px-4 py-3 flex items-start gap-3 ${TONE[t.severity] || TONE.info}`}
          data-testid={`toast-${t.severity}`}
        >
          <i className={`pi ${ICON[t.severity] || ICON.info} mt-0.5`} aria-hidden="true" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold m-0">{t.summary}</p>
            {t.detail && <p className="text-sm m-0 mt-1 break-words">{t.detail}</p>}
          </div>
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss"
            className="opacity-60 hover:opacity-100 transition-opacity"
          >
            <i className="pi pi-times text-xs" />
          </button>
        </div>
      ))}
    </div>
  )
}
